import React, { useState } from 'react';
import { TextField, Box, Button, Typography } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { post } from "src/services/httpClient.service";
import { useNavigate } from 'react-router';



const Resetpassword = () => {
    const navigate = useNavigate()
    const APIURL = process.env.REACT_APP_BASE_API_URL;
    const { showSnackbar } = useSnackbar();
    const logindetails = localStorage.getItem("operatorData")
    const [opearatordetails, setOperatordetails] = useState(
        logindetails ? JSON.parse(logindetails) : null
    );
    const [errors, setErrors] = useState<any>({});




    console.log('user', logindetails)
    console.log('opearatordetails', opearatordetails)

 const [userDetails, setUserdetails] = useState({
  email: opearatordetails?.email,
  accountType: opearatordetails.accountType,
  accountId: opearatordetails.id,
  oldPassword: '',
  newPassword: '',
  confPassword: '' 
});


    const validateForm = () => {
        const newErrors: any = {};

        if (!userDetails.oldPassword.trim()) {
            newErrors.oldPassword = "Enter your old password";
        }

        if (!userDetails.newPassword.trim()) {
            newErrors.newPassword = "Enter your new password";
        }

        if (userDetails.newPassword.length < 6) {
            newErrors.newPassword = "New password must be at least 6 characters";
        }

      /*   if (!userDetails.confpassword.trim()) {
            newErrors.confpassword = "Enter confirm password";
        }

        if (userDetails.newpassword !== userDetails.confpassword) {
            newErrors.confpassword = "Passwords do not match";
        } */

        /* if (userDetails.oldpassword === userDetails.newpassword) {
            newErrors.newpassword = "Old and new password cannot be same";
        } */

        if (!userDetails.email || !/\S+@\S+\.\S+/.test(userDetails.email)) {
            newErrors.email = "Enter a valid email";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0; // valid if no errors
    };




    const handleChange = (e) => {
        setUserdetails({
            ...userDetails,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async () => {
        console.log('')
   
        if (!validateForm()) {
            return;
        }
        try {
            const res = await post(`${APIURL}/api/account/reset-password`, userDetails);
            console.log("Response:", res.data);
            if (res?.status == 'ok' || res?.status == 201 || res?.status == 200) {
                showSnackbar(res?.data || 'Updated Password Successfully', 'success')
                localStorage.clear();
               
                setTimeout(() => {
                    navigate('/')
                }, 500);
            } else {
                showSnackbar(res?.data || 'Error', 'error')
            }


        } catch (err) {
            showSnackbar(err?.message || 'Error', 'error');

        }
    };


    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Box sx={{
                display: 'flex', flexDirection: 'column', gap: 2, width: '500px', marginTop: '20px',
                border: '1.5px solid #272C48', padding: "30px", borderRadius: '10px'
            }}>

                <Box sx={{ display: 'flex', justifyContent: "center", alignItems: 'center', gap: "2px" }}>
                    <LockOpenIcon sx={{ fontSize: "20px" }} />
                    <Typography variant='h4'>Resent your Password</Typography>
                </Box>

                <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={userDetails.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    disabled
                    fullWidth
                />

                <TextField
                    label="Account Type"
                    name="accounType"
                    value={userDetails.accountType}
                    onChange={handleChange}
                    disabled
                    fullWidth
                />

                <TextField
                    label="Account ID"
                    name="accountId"
                    value={userDetails.accountId}
                    onChange={handleChange}
                    disabled
                    fullWidth
                />

                <TextField
                    label="Old Password"
                    name="oldPassword"
                    type="password"
                    value={userDetails.oldPassword}
                    onChange={handleChange}
                    error={!!errors.oldPassword}
                    helperText={errors.oldPassword}
                    fullWidth
                />

                <TextField
                    label="New Password"
                    name="newPassword"
                    type="password"
                    value={userDetails.newPassword}
                    onChange={handleChange}
                    error={!!errors.newPassword}
                    helperText={errors.newPassword}
                    fullWidth
                />

                <TextField
                    label="Confirm Password"
                    name="confPassword"
                    type="password"
                    value={userDetails.confPassword}
                    onChange={handleChange}
                    error={!!errors.confPassword}
                    helperText={errors.confPassword}
                    fullWidth
                /> 

                <Button
                    variant="contained"
                    fullWidth
                    onClick={handleSubmit}
                >
                    Submit
                </Button>


            </Box>
        </Box>

    );
};

export default Resetpassword;
